import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const MainDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	z-index: 100;
`;

export const IconList = styled.div`
	display: flex;
`;

export const Icon = styled.img`
	width: 45px;
	height: auto;
	margin: 8px;
`;

export const StyledTypography = styled(Typography)`
	font-size: 24px;
	color: ${props => props.theme.label.color};
`;
